// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._t-0 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n._t-1 {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  margin: 15px 0;\n  border-radius: 0px;\n}\n\n._t-2 {\n  background-color: #11375b;\n}\n\n._t-3 {\n  text-wrap: wrap;\n}\n\n._t-4 {\n  text-decoration: underline;\n  font-weight: 400;\n  color: black;\n}\n\n._t-4._t-5 {\n    cursor: not-allowed;\n  }\n\n._t-4._t-6 {\n    cursor: wait;\n  }\n\n._t-7 {\n  gap: 0px;\n}\n\n._t-8 {\n  position: absolute;\n}\n", ""]);
// Exports
export var fullContainer = "_t-0";
export var coverageButtonContainer = "_t-1";
export var blue = "_t-2";
export var textWrap = "_t-3";
export var linkButton = "_t-4";
export var disabled = "_t-5";
export var pending = "_t-6";
export var noGap = "_t-7";
export var loader = "_t-8";
export default ___CSS_LOADER_EXPORT___;
